(function() {
  'use strict';

  angular.module('cfn').factory('shop.validation.service', ValidationService);

  ValidationService.$inject = ['$http', '$rootScope', 'i18nFilter'];

  /**
   * Validation for responses of shop REST calls.
   */
  function ValidationService($http, $rootScope, i18nFilter) {
    var processValidation = function processValidation(validationResult) {
      var len = validationResult.statusMessages.length;
      var message;

      for (; len--; ) {
        message = validationResult.statusMessages[len];
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter(message.textMessage.messageKey, 'An error occured.'),
          message.status
        );
      }
    };

    return {
      processValidation: processValidation
    };
  }
})();
